import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Table, TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DividerModule } from 'primeng/divider';

import { Deviatoio } from '@/core/models/models/pages/deviatoio';
import { DeviatoioService } from '@/core/service/deviatoio.service';
import { HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-deviatoi',
    standalone: true,
    providers: [ConfirmationService, MessageService],
    imports: [CommonModule, TableModule, ToolbarModule, ButtonModule, InputTextModule, ConfirmDialogModule, ToastModule, DividerModule, TooltipModule],
    templateUrl: './deviatoi.component.html',
    styleUrls: ['./deviatoi.component.scss']
})
export class Deviatoi implements OnInit {
    @ViewChild('dt') dt!: Table;

    deviatoi: Deviatoio[] = [];
    totalRecords = 0;
    loading = false;

    constructor(
        private service: DeviatoioService,
        private confirmation: ConfirmationService,
        private message: MessageService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.load();
    }

    load(): void {
        this.loading = true;
        this.service.list().subscribe({
            next: (res: HttpResponse<Deviatoio[]>) => {
                this.deviatoi = res.body ?? [];
                this.totalRecords = Number(res.headers.get('X-Total-Count')) || this.deviatoi.length;
            },
            error: () => (this.deviatoi = []),
            complete: () => (this.loading = false)
        });
    }

    /** Apre la pagina anagrafica: nuovo o modifica */
    openForm(row?: Deviatoio): void {
        this.router.navigate(['/anagrafica-deviatoi', row?.id ?? 'nuovo']);
    }

    onElimina(row: Deviatoio): void {
        this.confirmation.confirm({
            message: `Sei sicuro di voler eliminare il deviatoio “${row?.identificativo ?? row?.descrizione ?? row?.id}”?`,
            header: 'Conferma eliminazione',
            icon: 'pi pi-exclamation-triangle',
            acceptButtonStyleClass: 'p-button-danger',
            acceptIcon: 'pi pi-trash',
            rejectButtonStyleClass: 'p-button-text',
            accept: () => {
                this.service.delete(row.id!).subscribe({
                    next: () => {
                        this.message.add({ severity: 'success', summary: 'Eliminato', detail: 'Deviatoio eliminato' });
                        this.load();
                    },
                    error: () => this.message.add({ severity: 'error', summary: 'Errore', detail: 'Eliminazione non riuscita' })
                });
            }
        });
    }

    onExportCSV(): void {
        this.dt.exportCSV();
    }

    onSearch(event: any): void {
        this.dt.filterGlobal(event.target.value, 'contains');
    }
}
